import Bonus from './Bonus';

const DELTA_POWER = 6;

export default class Power extends Bonus {
  constructor({ game, player, values, road }) {
    super({
      game,
      player,
      values,
      road,
      name: 'power',
    });
    this._chance = 0.01;
    this._defaultPower = values.power;
  }
  _take() {
    super._take();
    this._playerData.power += DELTA_POWER;
    if (this._playerData.power > this._defaultPower) {
      this._playerData.power = this._defaultPower;
    }
    this._player.activateAnimation(this._name);
  }
}



// WEBPACK FOOTER //
// ./src/js/Power.js